import { SystemContentModel } from "../models/SystemContentModel";
import apiService from "./apiService";

const systemContentService = {
    getCommissionTermsContent: async () => {
        const response = await apiService.get(`/Content/CommissionTermsContent`);
        return new SystemContentModel(response);
    }
}
export default systemContentService;
